import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { KeyValue } from '../models/common';
import { IStateApi } from './base/stateApi';
import { StateFilterRequest, StatesFilterRequest } from '../models/request';
import { Result } from '../models/common/resultResponse';

const baseRoute: string = 'States';

export class StateApi extends IStateApi {
  getDomain(
    request: StateFilterRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }

  getDomainPublic( request: StateFilterRequest ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain_public`, { params: request });
  }

  getDomainByBodyshop( request: StatesFilterRequest ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domainByBodyshop`, { params: request });
  }
}
